import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { supabaseAdmin } from '../lib/supabaseAdmin';

const rolLabel = { super_admin: 'Süper Admin', admin: 'Admin', temsilci: 'Temsilci', depocu: 'Depocu', goruntuleme: 'Görüntüleme' };

export default function Kullanicilar() {
  const [kullanicilar, setKullanicilar] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [depolar, setDepolar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pasifGoster, setPasifGoster] = useState(false);
  const [modal, setModal] = useState(false);
  const [duzenleModal, setDuzenleModal] = useState(false);
  const [yetkilModal, setYetkilModal] = useState(false);
  const [seciliKullanici, setSeciliKullanici] = useState(null);
  const [yetkiler, setYetkiler] = useState([]);
  const [sifreGoster, setSifreGoster] = useState(false);
  const [sifreGosterDuzenle, setSifreGosterDuzenle] = useState(false);
  const [form, setForm] = useState({ email: '', sifre: '', ad: '', soyad: '', telefon: '', rol: 'temsilci', depo_id: '' });
  const [duzenleForm, setDuzenleForm] = useState({ ad: '', soyad: '', telefon: '', email: '', rol: 'temsilci', depo_id: '', yeniSifre: '' });
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    const [{ data: k }, { data: f }, { data: d }, authList] = await Promise.all([
      supabase.from('kullanicilar').select('*').order('ad'),
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
      supabase.from('depolar').select('id, ad').eq('aktif', true),
      supabaseAdmin.auth.admin.listUsers(),
    ]);
    // Auth'dan email bilgilerini tabloya eşleştir
    const authUsers = authList?.data?.users || [];
    const emailMap = {};
    authUsers.forEach(u => { emailMap[u.id] = u.email; });
    const kullanicilarWithEmail = (k || []).map(ku => ({ ...ku, email: emailMap[ku.id] || ku.email || '' }));
    setKullanicilar(kullanicilarWithEmail);
    setFirmalar(f || []);
    setDepolar(d || []);
    setLoading(false);
  }

  async function handleKaydet() {
    if (!form.email || !form.sifre || !form.ad) { setHata('E-posta, şifre ve ad zorunlu!'); return; }
    setYukleniyor(true);
    setHata('');
    // Admin API ile kullanıcı oluştur - email doğrulaması gerekmez
    const { data, error } = await supabaseAdmin.auth.admin.createUser({
      email: form.email,
      password: form.sifre,
      email_confirm: true,
      user_metadata: { ad: form.ad, soyad: form.soyad }
    });
    if (error) { setHata(error.message); setYukleniyor(false); return; }
    const userId = data?.user?.id;
    if (userId) {
      await supabase.from('kullanicilar').upsert({
        id: userId, ad: form.ad, soyad: form.soyad, telefon: form.telefon,
        rol: form.rol, depo_id: form.depo_id || null, aktif: true
      });
    }
    setBasari('Kullanıcı oluşturuldu! Hemen giriş yapabilir.');
    setModal(false);
    setYukleniyor(false);
    fetchData();
  }

  async function handleDuzenle() {
    if (!seciliKullanici || !duzenleForm.ad) return;
    setYukleniyor(true);
    setHata('');

    // Profil güncelle
    await supabase.from('kullanicilar').update({
      ad: duzenleForm.ad, soyad: duzenleForm.soyad, telefon: duzenleForm.telefon,
      rol: duzenleForm.rol, depo_id: duzenleForm.depo_id || null
    }).eq('id', seciliKullanici.id);

    // E-posta güncelle
    if (duzenleForm.email && duzenleForm.email !== seciliKullanici.email) {
      await supabaseAdmin.auth.admin.updateUserById(seciliKullanici.id, { email: duzenleForm.email });
    }

    // Şifre değiştir (varsa)
    if (duzenleForm.yeniSifre && duzenleForm.yeniSifre.length >= 6) {
      const { error } = await supabaseAdmin.auth.admin.updateUserById(seciliKullanici.id, {
        password: duzenleForm.yeniSifre
      });
      if (error) { setHata('Şifre güncellenemedi: ' + error.message); setYukleniyor(false); return; }
    }

    setDuzenleModal(false);
    setBasari('Kullanıcı güncellendi!');
    setYukleniyor(false);
    fetchData();
  }

  async function handleSil(k) {
    if (!window.confirm(k.ad + ' ' + k.soyad + ' kullanıcısını pasife almak istediğinizden emin misiniz?')) return;
    await supabase.from('kullanicilar').update({ aktif: false }).eq('id', k.id);
    setBasari('Kullanıcı pasife alındı!');
    fetchData();
  }

  async function handleAktifYap(k) {
    await supabase.from('kullanicilar').update({ aktif: true }).eq('id', k.id);
    setBasari(k.ad + ' ' + k.soyad + ' aktif edildi!');
    fetchData();
  }

  function duzenleAc(k) {
    setSeciliKullanici(k);
    setHata('');
    setSifreGosterDuzenle(false);
    setDuzenleForm({ ad: k.ad || '', soyad: k.soyad || '', telefon: k.telefon || '', email: k.email || '', rol: k.rol, depo_id: k.depo_id || '', yeniSifre: '' });
    setDuzenleModal(true);
  }

  async function yetkiAc(k) {
    setSeciliKullanici(k);
    const { data } = await supabase.from('temsilci_firma_yetki').select('firma_id').eq('kullanici_id', k.id);
    setYetkiler((data || []).map(y => y.firma_id));
    setYetkilModal(true);
  }

  async function yetkiKaydet() {
    await supabase.from('temsilci_firma_yetki').delete().eq('kullanici_id', seciliKullanici.id);
    if (yetkiler.length > 0) {
      await supabase.from('temsilci_firma_yetki').insert(yetkiler.map(firma_id => ({ kullanici_id: seciliKullanici.id, firma_id })));
    }
    setYetkilModal(false);
    setBasari('Firma yetkileri güncellendi!');
  }

  function toggleYetki(firma_id) {
    setYetkiler(prev => prev.includes(firma_id) ? prev.filter(id => id !== firma_id) : [...prev, firma_id]);
  }

  function f(key, val) { setForm(p => ({ ...p, [key]: val })); }
  function df(key, val) { setDuzenleForm(p => ({ ...p, [key]: val })); }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Kullanıcılar</h1>
          <p className="page-subtitle">{kullanicilar.length} kullanıcı kayıtlı</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className={`btn btn-sm ${pasifGoster ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setPasifGoster(p => !p)}>{pasifGoster ? 'Pasifler Gizle' : 'Pasifleri Göster'}</button>
          <button className="btn btn-primary" onClick={() => { setForm({ email: '', sifre: '', ad: '', soyad: '', telefon: '', rol: 'temsilci', depo_id: '' }); setHata(''); setSifreGoster(false); setModal(true); }}>+ Yeni Kullanıcı</button>
        </div>
      </div>

      {basari && <div className="alert alert-success" style={{ cursor: 'pointer' }} onClick={() => setBasari('')}>{basari} ✕</div>}

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr><th>Ad Soyad</th><th>E-posta</th><th>Telefon</th><th>Rol</th><th>Depo</th><th>İşlem</th></tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="loading">Yükleniyor...</td></tr>
            ) : kullanicilar.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Kullanıcı bulunamadı</td></tr>
            ) : kullanicilar.filter(k => pasifGoster ? true : k.aktif !== false).map(k => (
              <tr key={k.id}>
                <td style={{ fontWeight: 500, opacity: k.aktif === false ? 0.5 : 1 }}>{k.ad} {k.soyad} {k.aktif === false && <span style={{ fontSize: 11, color: "var(--red)", marginLeft: 4 }}>(Pasif)</span>}</td>
                <td style={{ color: 'var(--text2)', fontSize: 12 }}>{k.email || '-'}</td>
                <td style={{ color: 'var(--text2)' }}>{k.telefon || '-'}</td>
                <td><span className="badge badge-blue">{rolLabel[k.rol]}</span></td>
                <td style={{ color: 'var(--text2)', fontSize: 12 }}>{depolar.find(d => d.id === k.depo_id)?.ad || '-'}</td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-ghost btn-sm" onClick={() => duzenleAc(k)}>✏️ Düzenle</button>
                    {(k.rol === 'temsilci' || k.rol === 'admin') && (
                      <button className="btn btn-ghost btn-sm" onClick={() => yetkiAc(k)}>🏢 Yetki</button>
                    )}
                    {k.aktif !== false ? (
                      <button className="btn btn-danger btn-sm" onClick={() => handleSil(k)}>Pasife Al</button>
                    ) : (
                      <button className="btn btn-primary btn-sm" onClick={() => handleAktifYap(k)}>Aktife Al</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* YENİ KULLANICI */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Yeni Kullanıcı</h3>
            {hata && <div className="alert alert-error">{hata}</div>}
            <div className="form-row cols-2">
              <div className="form-group">
                <label className="label">Ad *</label>
                <input className="input" value={form.ad} onChange={e => f('ad', e.target.value)} autoComplete="off" autoFocus />
              </div>
              <div className="form-group">
                <label className="label">Soyad</label>
                <input className="input" value={form.soyad} onChange={e => f('soyad', e.target.value)} autoComplete="off" />
              </div>
              <div className="form-group">
                <label className="label">E-posta *</label>
                <input className="input" type="email" value={form.email} onChange={e => f('email', e.target.value)} autoComplete="off" placeholder="ornek@email.com" />
              </div>
              <div className="form-group">
                <label className="label">Telefon</label>
                <input className="input" value={form.telefon} onChange={e => f('telefon', e.target.value)} autoComplete="off" maxLength={15} />
              </div>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label className="label">Şifre *</label>
                <div style={{ position: 'relative' }}>
                  <input className="input" type={sifreGoster ? 'text' : 'password'} value={form.sifre} onChange={e => f('sifre', e.target.value)} autoComplete="new-password" style={{ paddingRight: 44 }} />
                  <button type="button" onClick={() => setSifreGoster(!sifreGoster)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text2)', fontSize: 18 }}>
                    {sifreGoster ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label className="label">Rol</label>
                <select className="select" value={form.rol} onChange={e => f('rol', e.target.value)}>
                  {Object.entries(rolLabel).map(([val, lbl]) => <option key={val} value={val}>{lbl}</option>)}
                </select>
              </div>
              {form.rol === 'depocu' && (
                <div className="form-group">
                  <label className="label">Depo</label>
                  <select className="select" value={form.depo_id} onChange={e => f('depo_id', e.target.value)}>
                    <option value="">Depo Seçin</option>
                    {depolar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                  </select>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleKaydet} disabled={yukleniyor}>{yukleniyor ? 'Oluşturuluyor...' : 'Kullanıcı Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      {/* DÜZENLE */}
      {duzenleModal && (
        <div className="modal-overlay" onClick={() => setDuzenleModal(false)}>
          <div className="modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Kullanıcı Düzenle — {seciliKullanici?.ad}</h3>
            {hata && <div className="alert alert-error">{hata}</div>}
            <div className="form-row cols-2">
              <div className="form-group">
                <label className="label">Ad *</label>
                <input className="input" value={duzenleForm.ad} onChange={e => df('ad', e.target.value)} autoComplete="off" />
              </div>
              <div className="form-group">
                <label className="label">Soyad</label>
                <input className="input" value={duzenleForm.soyad} onChange={e => df('soyad', e.target.value)} autoComplete="off" />
              </div>
              <div className="form-group">
                <label className="label">Telefon</label>
                <input className="input" value={duzenleForm.telefon} onChange={e => df('telefon', e.target.value)} autoComplete="off" maxLength={15} />
              </div>
              <div className="form-group">
                <label className="label">E-posta (Giriş Adresi)</label>
                <input className="input" type="email" value={duzenleForm.email} onChange={e => df('email', e.target.value)} autoComplete="off" />
              </div>
              <div className="form-group">
                <label className="label">Rol</label>
                <select className="select" value={duzenleForm.rol} onChange={e => df('rol', e.target.value)}>
                  {Object.entries(rolLabel).map(([val, lbl]) => <option key={val} value={val}>{lbl}</option>)}
                </select>
              </div>
              {duzenleForm.rol === 'depocu' && (
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="label">Depo</label>
                  <select className="select" value={duzenleForm.depo_id} onChange={e => df('depo_id', e.target.value)}>
                    <option value="">Depo Seçin</option>
                    {depolar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                  </select>
                </div>
              )}
            </div>
            <div className="divider" />
            <div className="form-group">
              <label className="label">Yeni Şifre <span style={{ color: 'var(--text3)', fontWeight: 400 }}>(boş bırakırsan değişmez)</span></label>
              <div style={{ position: 'relative' }}>
                <input className="input" type={sifreGosterDuzenle ? 'text' : 'password'} value={duzenleForm.yeniSifre} onChange={e => df('yeniSifre', e.target.value)} placeholder="En az 6 karakter" autoComplete="new-password" style={{ paddingRight: 44 }} />
                <button type="button" onClick={() => setSifreGosterDuzenle(!sifreGosterDuzenle)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text2)', fontSize: 18 }}>
                  {sifreGosterDuzenle ? '🙈' : '👁️'}
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
              <button className="btn btn-ghost" onClick={() => setDuzenleModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleDuzenle} disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}

      {/* FİRMA YETKİ */}
      {yetkilModal && (
        <div className="modal-overlay" onClick={() => setYetkilModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">{seciliKullanici?.ad} — Firma Yetkileri</h3>
            <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>Hangi firmaların ürünlerini satabilir?</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
              {firmalar.map(fi => (
                <label key={fi.id} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', padding: '10px 14px', background: yetkiler.includes(fi.id) ? 'rgba(224,123,0,0.1)' : 'var(--bg3)', borderRadius: 'var(--r)', border: `1px solid ${yetkiler.includes(fi.id) ? 'var(--accent)' : 'var(--border)'}` }}>
                  <input type="checkbox" checked={yetkiler.includes(fi.id)} onChange={() => toggleYetki(fi.id)} />
                  <span style={{ fontWeight: yetkiler.includes(fi.id) ? 600 : 400 }}>{fi.ad}</span>
                </label>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setYetkilModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={yetkiKaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
